import useGetProjectByIdOverview from '@/api/queries/project/useGetProjectByIdOverview';
import AuthenticatedPageWrapper from '@/ui/pages/pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';
import { BreadcrumbItem, Card, EmptyState } from '@payaca/ambrosia';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

const ProposalBuilderPage: FC = () => {
  const { projectId, proposalId } = useParams<{
    projectId: string;
    proposalId: string;
  }>();

  const { project } = useGetProjectByIdOverview(projectId);

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: project?.pipeline.name ?? 'Pipeline',
      to: project?.pipeline
        ? `/pipelines/${project.pipeline.publicId}`
        : undefined,
    },
    {
      label: project ? `Project: #${project.reference}` : 'Project',
      to: `/projects/${projectId}`,
    },
    {
      label: 'Proposal',
    },
  ];

  return (
    <AuthenticatedPageWrapper breadcrumbItems={breadcrumbItems}>
      <Card>
        <Card.Body>
          <EmptyState
            text={`Proposal builder for ${proposalId} — coming soon.`}
          />
        </Card.Body>
      </Card>
    </AuthenticatedPageWrapper>
  );
};

export default ProposalBuilderPage;
